// extracted by mini-css-extract-plugin
export default {"paymentFrame":"elavon-lightbox-form_paymentFrame__8lSQL","spinner":"elavon-lightbox-form_spinner__Jl6UO","inputWrapper":"elavon-lightbox-form_inputWrapper__ZtwoO"};